var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{class:{'checkmark': _vm.value},staticStyle:{"height":"60px","width":"60px","margin":"0px"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 52 52"}},[_c('circle',{class:{
    'checkmark__circle': _vm.value
  },attrs:{"cx":"26","cy":"26","r":"25","fill":"none"}}),_c('path',{class:{
    'checkmark__check': _vm.value
  },attrs:{"fill":"none","d":"M14.1 27.2l7.1 7.2 16.7-16.8"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }